import { render, staticRenderFns } from "./MonthlyModal.vue?vue&type=template&id=061a5b39&scoped=true&"
import script from "./MonthlyModal.vue?vue&type=script&lang=js&"
export * from "./MonthlyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a5b39",
  null
  
)

export default component.exports